import type { ReactNode } from 'react';
import { MenuItem, TypePill, templateColorVariant } from '@wundo/ui';
import { Check } from 'lucide-react';
import type { MeetingTemplateColor } from '@wundo/shared/meetingTemplate.ts';

export interface MeetingTypeRowProps {
  /** Whether this is the type the meeting follows now. */
  on: boolean;
  color: MeetingTemplateColor;
  onPick: () => void;
  children: ReactNode;
}

/*
 * The one that is on is a filled row, the same signal the filter menu gives a
 * ticked one: the surface shows the current choice before a name is read. The
 * tick's colour is forced because the menu paints every icon in it muted.
 */
export function MeetingTypeRow({ on, color, onPick, children }: MeetingTypeRowProps) {
  return (
    <MenuItem disabled={on} onClick={onPick} className={on ? 'bg-fill' : undefined}>
      {/* The colour it wears everywhere else, so the menu shows the choice itself. */}
      <TypePill type={templateColorVariant(color)} size='sm'>
        {children}
      </TypePill>
      {on && <Check aria-hidden='true' className='ml-auto text-accent!' />}
    </MenuItem>
  );
}
